/**
 * Calcula e formata o valor total dos pagamentos.
 *
 * A função percorre o array de pagamentos (responsePagamento), 
 * extrai os dígitos do valor de cada pagamento, converte para número e acumula.
 * O total acumulado é então formatado para o padrão monetário brasileiro (R$ x.xxx,xx).
 *
 * @param {Array} responsePagamento - Array de objetos de pagamento, onde cada objeto contém um valor no formato monetário.
 * @returns {string} O valor total formatado como moeda brasileira.
 */
export function money(responsePagamento) {
    let total = 0;
    responsePagamento.map((resp) => {
        let currency = resp.valor.replace(/\D/g, "");
        let curr = parseFloat(currency) / 100;
        total = total + curr;
    });

    let totalF = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(total);

    return totalF;
}